export interface SelectOption {
  id: number;
  value: string;
}

/**
 * Custom attribute definition with optional value.
 * `options` holds the available choices for select types.
 * `value` holds the current scalar value for non-select types.
 * `selectedOptions` holds the chosen options for select types.
 */
export interface CustomAttribute {
  id: number;
  name: string;
  type: CustomAttributeType;
  value?: boolean | string | number | null;
  selectedOptions?: SelectOption[];
  options?: SelectOption[];
}

export enum CustomAttributeType {
  Text = 'STRING',
  Number = 'NUMBER',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Select = 'SINGLESELECT',
  MultiSelect = 'MULTISELECT',
}

/**
 * Custom attributes stored in form state as a key-value record.
 * Key is the attribute name (lowercased, spaces removed).
 * For select types, value is option ID as string (single) or string[] (multi).
 * For non-select types, value is the raw scalar.
 */
export type CustomAttributesFormData = Record<string, boolean | string | number | string[] | null>;
